// ============================================================
// TargetTemplatesMenu - the target header's Templates dropdown
// ============================================================
// Load a saved target template, delete one, or save the current target
// as a new one. The templates and their handlers live in TargetsContext.

import clsx from '../utils/clsx';
import { activatable, onActivateKey } from '../utils/keyActivation';
import common from '../styles/common.module.css';
import styles from '../styles/TargetPanel.module.css';

/** The Templates button and, when `open`, its dropdown. */
export default function TargetTemplatesMenu({
  open,
  onToggle,
  templates,
  onLoad,
  onDelete,
  newName,
  onNewName,
  onSave,
}) {
  const names = Object.keys(templates);
  return (
    <div style={{ position: 'relative' }}>
      <button className={common.btnSmall} onClick={onToggle}>
        Templates &#9660;
      </button>
      {open && (
        <div className={common.dropdown} style={{ right: 0 }}>
          {names.length === 0 && <div className={styles.noTemplates}>No templates yet</div>}
          {names.map((n) => (
            <TemplateEntry key={n} name={n} onLoad={onLoad} onDelete={onDelete} />
          ))}
          <div style={{ borderTop: '1px solid var(--border-medium)', padding: 6 }}>
            <input
              className={common.input}
              style={{ width: '100%', marginBottom: 4, boxSizing: 'border-box' }}
              placeholder="Save current as..."
              value={newName}
              onChange={(e) => onNewName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onSave(newName)}
            />
            <button className={common.btnSmall} style={{ width: '100%' }} onClick={() => onSave(newName)}>
              Save Template
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function TemplateEntry({ name, onLoad, onDelete }) {
  return (
    <div className={clsx(common.dropdownItem, styles.templateEntry)}>
      <span className={styles.templateName} {...activatable(() => onLoad(name))}>
        Load: {name}
      </span>
      <span
        className={styles.templateDelete}
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(name);
        }}
        onKeyDown={onActivateKey(() => onDelete(name))}
        title={'Delete template: ' + name}
      >
        &#10005;
      </span>
    </div>
  );
}
